import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/home/home.service';
import { BaseResponse } from '../models/base-response.model';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { FileService } from 'src/app/shared/file-service/file.service';

@Component({
  selector: 'release-banner',
    templateUrl: './release-banner-component.html',
    styleUrls: ['./release-banner-component.scss']
})
export class ReleaseBannerComponent implements OnInit {
    isReleaseNoteBannerClosed: boolean = true;
    showReleaseNoteBanner: boolean = false;
    constructor(private _homeService: HomeService,
        public sessionService: SessionService,
        public toastrService: ToastrService,
        private _loader: LoadingIndicatorService,
        private _fileService: FileService) { 
  
  }

    ngOnInit() {
       this.showReleaseBanner();
    }

    showReleaseBanner() {
        this._homeService.GetUserNotifiedDetail().subscribe(
            (data: boolean) => {
                this.showReleaseNoteBanner = data;
            });
    }

    hideBanner() {
        this._homeService.UpdateUserNotifiedDetail().subscribe(() => {
            this.showReleaseBanner();
        });
    }

    downloadReleaseNotes() {
        this._loader.display(true, true);
        this._homeService.GetReleaseNotesDownload().subscribe(
            blob => {
                const fileName = "Latest RCN Release Notes";
                const extention = '.pdf';
                this._fileService.saveBlobToFile(blob, `${fileName}${extention}`);
                this._loader.display(false);
            },
            error => {
                this._loader.display(false);               
                return;
            }
        );
    }   

}
